import React from 'react';
// import mission component
import MissionData from '../components/MissionData';

const Mission = () => (
  <div>
    <MissionData />
  </div>
);

export default Mission;
